import { ApiData } from 'states/types'
import { NivosUser } from 'types/user'

const Types = {
  SET: '@@user-admin/SET',
  ADD: '@@user-admin/ADD',
  UPDATE: '@@user-admin/UPDATE',
  LOADING: '@@user-admin/LOADING',
  DELETE: '@@user-admin/DELETE'
}

export type Payload = ApiData<NivosUser>

export { Types }
